import styles from './App.module.css'
import './styles/animations.css'
import React, { useEffect } from "react"
import { Route, Routes, useLocation } from 'react-router-dom'
import Navbar from './components/Navbar'
import Home from './pages/Home'
import About from './pages/About'
import Rush from './pages/Rush'
import Footer from './components/Footer'
import Brothers from './pages/Brothers'
import { Analytics } from '@vercel/analytics/react'

function App() {
	const location = useLocation();

	useEffect(() => {
		window.scrollTo({ top: 0, left: 0, behavior: 'instant'});
	}, [location]);

	useEffect(() => {
		const timer = setTimeout(() => {
			const observer = new IntersectionObserver(
				(entries) => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							entry.target.classList.add('in-view');
							observer.unobserve(entry.target);
						}
					});
				},
				{ threshold: 0.1, rootMargin: '0px 0px -30px 0px' }
			);
			document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
			return () => observer.disconnect();
		}, 60);
		return () => clearTimeout(timer);
	}, [location]);

	return (
		<div className={styles.page}>
			<div className={styles.header}>
				<Navbar />
			</div>
			<div className={styles.body}>
				<Routes>
					<Route index element={<Home />} />
					<Route path="home" element={<Home />} />
					<Route path="about" element={<About />} />
					<Route path="rush" element={<Rush />} />
					<Route path="brothers" element={<Brothers />} />
				</Routes>
			</div>
			<div className={styles.footer}>
				<Footer />
			</div>
			<Analytics />
		</div>
	)
}

export default App